import { TFunction } from "i18next";
import { ReportedCheck } from "./fleetCheckRow";

/**
 * What each check is called.
 *
 * Mostly the labels the single-vehicle checklist already uses: the two views ask the same
 * question of the same readings, so they must not come to call it different things — the same
 * argument that put the recognition rules in one module.
 *
 * Two have their own key because a column heading has to be short where a checklist line can
 * spell it out.
 */
const LABEL_KEYS: Record<ReportedCheck, string> = {
  ignition: "liveData.checklist.ignition",
  vehicleSpeed: "liveData.checklist.vehicleSpeed",
  engineSpeed: "liveData.checklist.engineSpeed",
  deviceVoltage: "vehicleDataCheck.checks.deviceVoltage",
  fuelLevel: "liveData.checklist.fuelLevel",
  fuelLevelLiters: "liveData.checklist.fuelLevelLiters",
  defLevel: "liveData.checklist.defLevel",
  hvBatteryVoltage: "liveData.checklist.hvBatteryVoltage",
  hvBatteryCurrent: "liveData.checklist.hvBatteryCurrent",
  hvBatteryPower: "liveData.checklist.hvBatteryPower",
  stateOfCharge: "vehicleDataCheck.checks.stateOfCharge",
};

export function checkLabel(check: ReportedCheck, t: TFunction): string {
  return t(LABEL_KEYS[check]);
}
